"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CACHE_LIFETIME = void 0;
exports.CACHE_LIFETIME = 1000;
//# sourceMappingURL=config.js.map